// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR = "Baz\u00e1r";
export const BZ2_ADD_PRODUCT = "Pridaj inzer\u00e1t";
export const BZ2_FAQ = "Ako funguje baz\u00e1r?";
export const BZ2_WISHLIST = "Ulo\u017een\u00e9 inzer\u00e1ty";
export const FORUM = "Diskusie";
export const GROUP_LIST = "Zoznam skup\u00edn";
export const HEADING_SELLERS = "Moji ob\u013e\u00faben\u00ed";
export const LOG_IN = "Prihl\u00e1s&nbsp;sa";
export const MY_ENTRIES = "M\u00f4j baz\u00e1r";
export const MY_SHOPPING = "Moje n\u00e1kupy";
export const PB_MENU_FIND_MOM = "N\u00e1jdi mami\u010dku";
export const PB_MENU_MY_ACTIVITY = "Zapojila som sa";
export const PHOTOBLOGS = "Skupiny a blogy";
export const REGISTER_HERE = "Zaregistruj sa tu!";
export const SERVER_FULL_NAME = "Modr\u00fd kon\u00edk";
export const SERVER_SLOGAN = "Str\u00e1nka pre mami\u010dky a bud\u00face mami\u010dky";
